import { message, Radio } from "antd";
import React from "react";
/** @jsxImportSource @emotion/react */
import tw, { styled } from "twin.macro";
import { isEmpty } from "../../lib/helpers/helpers";

const RadioContainer = styled.div`
	.ant-radio {
		top: 0;
	}
	.ant-radio-wrapper {
		${tw`inline-flex items-center`}
		font-size: 12px;
		line-height: 21px;
		color: #323232;
		opacity: 0.7;

		@media (max-width: 523px) {
			font-size: 10px;
		}

		.ant-radio-inner {
			${tw`h-6 w-6`}
			background: rgba(20, 20, 20, 0.06);
			border: 1px solid #ff5a62;
			&::after {
				content: "";
				background: #fff;
				border: 1px solid #ddd;
				display: inline-flex;
				align-items: center;
				justify-content: center;
				width: 16px;
				height: 16px;
				padding: 2px;
			}
		}
		.ant-radio-checked {
			background: #ff5a62 !important;
			border: 1px solid #ff5a62 !important;
			border-radius: 50%;
		}
	}
`;

const CustomRadio = (props) => {
	const { defaultValue, updateProgress, planId, refetch } = props;

	const handleUpdate = async (e) => {
		if (isEmpty(planId)) {
			return;
		}
		const data = {
			planId: planId,
			progress: e.target.value,
		};
		console.log("datra", data);
		try {
			message.loading("Updating current status");
			const response = await updateProgress(data);
			console.log("\nUpdate plan res: =====>\n", response.data);
			const { hasError } = response.data;
			if (hasError) {
				return message.error(response.data.errors.title);
			}
			message.success("Status updated");
			setTimeout(() => {
				refetch();
			}, 500);
		} catch (err) {
			console.log("Error: ", err);
		}
	};

	return (
		<RadioContainer>
			<Radio.Group
				name="radiogroup"
				value={defaultValue}
				onChange={handleUpdate}>
				<Radio value={"pending"}>Not done</Radio>
				<Radio value={"ongoing"}>Ongoing</Radio>
				<Radio value={"done"}>Done</Radio>
			</Radio.Group>
		</RadioContainer>
	);
};

export default CustomRadio;
